import React from 'react';
import Select from 'react-select';

import { SelectFilter, Filter } from '../FilterTypes';
import { customStyles } from '../form/fields/Select';

interface Props {
    filter: SelectFilter;
    filterChanged: (filter: Filter, event: React.ChangeEvent<HTMLInputElement> | unknown) => void;
    withIsSelected: boolean;
}

export default class SelectFilterField extends React.Component<Props> {
    private getSelectValue(filter: SelectFilter) {
        const value = filter.value;
        if (value === null || value === undefined || value === '') {
            return null;
        }
        if (typeof value === 'object') {
            return value;
        }
        return filter.options?.find((opt) => opt.value === value) ?? { value, label: String(value) };
    }

    checkbox(filter: SelectFilter) {
        return (
            <input
                checked={filter.isSelected}
                name={filter.name + 'Selected'}
                onChange={(e) => this.props.filterChanged(filter, e)}
                type="checkbox"
            />
        );
    }

    render() {
        const filter = this.props.filter;
        return (
            <div className="wfp-form--group" key={filter.name}>
                <label htmlFor="selection">{filter.label}:</label>
                {this.props.withIsSelected && this.checkbox(filter)}
                <div className="replaced-form-input">
                    <Select
                        className="react-select-container"
                        isMulti={false}
                        name={filter.name}
                        onChange={(e) => this.props.filterChanged(filter, e)}
                        options={filter.options}
                        searchable={false}
                        styles={customStyles}
                        value={this.getSelectValue(filter)}
                    />
                </div>
            </div>
        );
    }
}
